import { makeAutoObservable } from "mobx";

interface UserObject {
  id?: string;
  first_name: string;
  last_name: string;
  en_first_name: string;
  en_last_name: string;
  email: string;
  phone: string;
  selectedBranch: string;
  avatar_url?: string;
  default_currency?: string;
  home_currency?: string;
  enabled_currencies?: string[];
}

class User {
  id?: string;
  first_name?: string;
  last_name?: string;
  en_first_name?: string;
  en_last_name?: string;
  email?: string;
  phone?: string;
  selectedBranch?: string;
  avatar_url?: string;
  default_currency?: string;
  home_currency?: string;
  enabled_currencies?: string[];

  constructor() {
    makeAutoObservable(this);
  }

  setUser({
    id,
    first_name,
    last_name,
    email,
    phone,
    en_first_name,
    en_last_name,
    selectedBranch,
    avatar_url,
    default_currency,
    home_currency,
    enabled_currencies,
  }: UserObject): void {
    this.id = id;
    this.first_name = first_name;
    this.last_name = last_name;
    this.en_first_name = en_first_name;
    this.en_last_name = en_last_name;
    this.email = email;
    this.phone = phone;
    this.selectedBranch = selectedBranch;
    this.avatar_url = avatar_url;
    this.default_currency = default_currency;
    this.home_currency = home_currency;
    this.enabled_currencies = enabled_currencies;
  }

  setAvatarUrl(avatar_url: string): void {
    this.avatar_url = avatar_url;
  }

  setPhone(phone: string): void {
    this.phone = phone;
  }
}

export default User;
